"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryString = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const browser_1 = require("./browser");
const common_1 = require("./common");
exports.queryString = {
    get(key) {
        return (0, get_1.default)(this.parse(), key);
    },
    parse(query) {
        if (!(0, common_1.hasWindow)())
            return null;
        if (!query)
            query = location.search.substring(1);
        return Object.fromEntries(new URLSearchParams(query));
    },
    stringify(v) {
        const params = new URLSearchParams();
        Object.entries(v).forEach(([key, value]) => {
            params.append(key, value);
        });
        return params.toString();
    },
    set(key, value = '') {
        const params = (0, isString_1.default)(key) ? { [key]: value } : key;
        return (0, browser_1.changeLocationQuery)(exports.queryString.stringify(Object.assign(Object.assign({}, (exports.queryString.parse() || {})), params)));
    },
    remove(...keys) {
        if (!keys.length)
            (0, browser_1.changeLocationQuery)('');
        return (0, browser_1.changeLocationQuery)(exports.queryString.stringify((0, omit_1.default)(exports.queryString.parse() || {}, ...keys)));
    },
};
